<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu duyệt gán</h1>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              v-model.trim="filters.orderCode"
              type="text"
              placeholder="Mã phiếu"
              style="border-radius: 4px"
              @keyup.enter.prevent="search()"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <!--          <div class="form-group">-->
          <!--            <Select2-->
          <!--              v-model="filters.businessRegionCode"-->
          <!--              :options="dataConfigRegion"-->
          <!--              @change="queryProvince($event)"-->
          <!--              placeholder="Vùng kinh doanh"-->
          <!--            />-->
          <!--          </div>-->
          <!--          <div class="form-group">-->
          <!--            <Select2-->
          <!--              v-model="filters.businessProvinceCode"-->
          <!--              :options="dataProvince"-->
          <!--              :disabled="-->
          <!--                !filters.businessRegionCode ||-->
          <!--                filters.businessRegionCode === '0'-->
          <!--              "-->
          <!--              placeholder="Tỉnh/Thành phố kinh doanh"-->
          <!--            />-->
          <!--          </div>-->
          <div class="form-group">
            <Select2
              v-model="filters.createdBy"
              :options="dataStaff"
              placeholder="Người tạo"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.status"
              :options="Config.getSearch(listStatus)"
              placeholder="Trạng thái duyệt gán"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.levelAssign"
              :options="listLevelAssign"
              placeholder="Đối tượng gán"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :options="listUser"
              placeholder="NV chăm sóc cần cập nhật"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              @click="submitForm()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>

      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="">
              <div class="d-flex flex-row">
                <div class="box-header list_total">
                  <TotalCountCheck :totals="totalCount" :data="totals"></TotalCountCheck>
                </div>
              </div>
              <b-table
                :busy.sync="loading"
                head-variant="light"
                sticky-header
                hover
                responsive
                :items="dataTable"
                :fields="fieldsTable"
                selectable
                show-empty
                select-mode="single"
                :fixed="true"
                :bordered="true"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-info my-2">Không có dữ liệu</div>
                </template>
                <template #cell(index)="data">
                  <div class="">{{ data.index + 1 }}</div>
                </template>
                <template #cell(merchantCode)="{ item }">
                  <b-link
                    class="font-bold text-primary cursor-pointer"
                    :href="`/customer-support/assign-order/${item.id}`"
                    target="_blank"
                    style="color: #0056f6"
                    size="sm"
                    >{{ item.orderCode }}</b-link
                  >
                </template>

                <template #cell(userApprove)="{ item }">
                  <div>
                    <b class="text-info">Người tạo:</b>
                    <span class="text-primary">
                      {{ item.createdByName }} -
                      {{ getRole(item.createdByRole) }}
                    </span>
                  </div>
                  <div v-if="item.approvedByName">
                    <b class="text-info">{{
                      item.status === 'CANCELED' ? 'Người huỷ:' : 'Người duyệt/từ chối:'
                    }}</b>
                    <span class="">
                      {{ item.approvedByName }} -
                      {{ getRole(item.approvedByRole) }}
                    </span>
                  </div>
                </template>

                <template #cell(datetime)="{ item }">
                  <div>
                    <b class="text-info">Tạo: </b>
                    <span class="">
                      {{ item.createdDate | formatDate('DD/MM/YYYY HH:mm:ss') }}</span
                    >
                  </div>
                  <div v-if="item.approvedDate">
                    <b class="text-info">
                      {{ getStatusTag(item.status) }}
                    </b>
                    <span class="">
                      {{ item.approvedDate | formatDate('DD/MM/YYYY HH:mm:ss') }}</span
                    >
                  </div>
                </template>
                <template #cell(staffAssigns)="{ item }">
                  <staff-assign :item="item.staffAssigns" :type="'assignType'"></staff-assign>
                </template>
                <template #cell(totalAssign)="{ item }">
                  <div v-if="totalAssign(item)">Tổng: {{ totalAssign(item) }}</div>
                  <div v-if="item.successAssignAmount" class="text-success">
                    Thành công: {{ item.successAssignAmount }}
                  </div>
                  <div v-if="item.failedAssignAmount" class="text-danger">
                    Thất bại: {{ item.failedAssignAmount }}
                  </div>
                </template>
                <template #cell(levelAssign)="{ item }">
                  <div>
                    {{ getNameLevelAssign(item.levelAssign) }}
                  </div>
                </template>
                <template #cell(status)="{ item }">
                  <div class="">
                    <span :class="`badge ${getStatusClass(item.status)}`">
                      {{ getStatusName(item.status) }}
                    </span>
                    <div class="mt-1" v-if="item.reason">Lý do: {{ item.reason }}</div>
                  </div>
                </template>
                <template #cell(actions)="{ item }">
                  <div class="text-center">
                    <b-link
                      :href="`/customer-support/assign-order/${item.id}`"
                      target="_blank"
                      style="color: #0056f6"
                      size="sm"
                    >
                      <img
                        src="@/assets/img/circle-three-dots.svg"
                        alt="Circle with Three Dots"
                        style="width: 15px; height: 15px"
                      />
                      Chi tiết
                    </b-link>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end pagination-bottom">
          <b-form-group class="mb-0" style="padding: 17px">
            <b-form-select
              v-model="pagination.limit"
              :options="pageOptions"
              @change="onItemsPerPageChange"
            ></b-form-select>
          </b-form-group>
          <b-pagination
            v-model="pagination.page"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="pagination.limit"
            class="mr-2 fl-right"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { List } from '@/services/customer-support/assign_order'
  import { StaffService } from '@/services/staff.service'
  import TotalCountCheck from '@/components/cskh/Counts.vue'
  import { CommonService } from '@/services/common.service'
  import { MaRole } from '@/constant/customerSupport'
  import StaffAssign from '@/components/cskh/StaffAssign.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    {
      key: 'merchantCode',
      label: 'Mã phiếu yêu cầu',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'userApprove',
      label: 'Người tạo/Người duyệt',
      thStyle: 'min-width: 150px',
    },
    { key: 'datetime', label: 'Thời gian', thStyle: 'min-width: 100px' },
    {
      key: 'staffAssigns',
      label: 'NV chăm sóc cần cập nhật',
      thStyle: 'min-width: 120px',
    },
    {
      key: 'totalAssign',
      label: 'Số lượng merchant',
      thStyle: 'min-width: 150px',
    },
    {
      key: 'levelAssign',
      label: 'Đối tượng gán',
      thStyle: 'min-width: 100px',
    },
    {
      key: 'status',
      label: 'Trạng thái duyệt gán',
      thStyle: 'min-width: 100px',
    },
    {
      key: 'actions',
      label: 'Thao tác',
      fixIndex: 999,
      class: 'text-center',
      thStyle: 'min-width: 80px',
    },
  ]

  export default {
    components: { StaffAssign, TotalCountCheck },
    data() {
      return {
        listLevelAssign: [
          { id: 'STORE', text: 'Cửa hàng' },
          { id: 'MERCHANT_OWNER', text: 'Merchant Owner' },
          { id: 'MERCHANT_ACCOUNT', text: 'Merchant Account' },
        ],
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        Config,
        fieldsTable,
        MaRole,
        showLoading: false,
        totalCount: 0,
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        totals: [],
        listStatus: [],
        listUser: [],
        listStaffAssigns: [],
        filters: {
          orderCode: '',
          createdDate: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          createdBy: '',
          status: '',
          levelAssign: '',
          staffId: '',
        },
        localeData: Config.localeData,
        loading: false,
        dataStaff: [],
        dataConfigRegion: [],
        dataProvince: [],
        optionMerchantType: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        dataTable: [],
      }
    },
    async created() {
      await Promise.allSettled([
        this.configSystem(),
        // this.getRegions(),
        this.getDataStaff(),
        this.getListStaffBySuperior(),
      ])
      await this.buildQuery()
    },
    computed: {
      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
    },
    methods: {
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: '', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      getStatusTag(status) {
        return status === 'APPROVED'
          ? 'Duyệt:'
          : status === 'REJECTED'
            ? 'Từ chối:'
            : status === 'CANCELED'
              ? 'Huỷ:'
              : ''
      },
      getNameLevelAssign(key) {
        const obj = {
          STORE: 'Cửa hàng',
          MERCHANT_OWNER: 'Merchant Owner',
          MERCHANT_ACCOUNT: 'Merchant Account',
        }
        return obj[key] || key
      },
      async getDataStaff() {
        try {
          this.loading = true
          const response = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          this.dataStaff =
            response.data?.map(s => ({
              id: s.userId,
              text: `${s.name} - ${s.userName}`,
            })) ?? []
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      transformDate() {
        this.search.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.toDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      async clearSearch() {
        this.filters = {
          orderCode: '',
          createdDate: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          createdBy: '',
          status: '',
        }
        this.pagination = {
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }

        await this.buildQuery()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const orderCode = this.filters.orderCode?.trim()
        if (orderCode) {
          conditions.push(`{orderCode} LIKE '''${orderCode}'''`)
        }

        const listKey = [
          'businessRegionCode',
          'businessProvinceCode',
          'createdBy',
          'status',
          'levelAssign',
          'staffAssigns',
        ]

        listKey.forEach(key => {
          if (this.filters[key] && this.filters[key] !== '0') {
            conditions.push(`{${key}} == '''${this.filters[key]}'''`)
          }
        })

        this.dateRange.startDate &&
          this.dateRange.endDate &&
          conditions.push(
            `{createdDate} range [#${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )

        const listKeyParams = ['staffId']

        listKeyParams.forEach(key => {
          if (this.filters[key]) {
            conditionsMap[key] = this.filters[key]
          }
        })

        this.pagination.queryString = conditions.join(' AND ')
        await this.loadData(conditionsMap)
      },

      async loadData(conditionsMap = {}) {
        try {
          this.loading = true
          const searchQuery = {
            countStatus: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            queryString: this.pagination.queryString,
            ...conditionsMap,
            sort: {
              direction: this.pagination.sortType,
              properties: [this.pagination.sortField],
            },
          }
          const res = await List(searchQuery)
          if (res.data.listData) {
            this.dataTable = res.data.listData.map(el => {
              return {
                ...el,
                checked: false,
              }
            })
          } else {
            this.dataTable = []
          }
          this.pagination.total = res.data.totalCount
          this.totalCount = res.data.totalCount ?? 0
          if (res.data.listCountStatus) {
            this.totals = res.data.listCountStatus
              .filter(item => item.status)
              .sort((a, b) => a.status.localeCompare(b.status))
              .reduce((acc, item) => {
                const status = acc.find(s => s.status === item.status)
                if (status) {
                  status.count += item.count
                } else {
                  const statusObj = this.listStatus.find(list => list.id == item.status)
                  acc.push({
                    status: statusObj?.text || item.status,
                    status_class: statusObj?.class ?? 'text-primary',
                    count: item.count,
                  })
                }
                return acc
              }, [])
          } else {
            this.totals = []
          }
        } catch (e) {
          this.showToastError(e.message)
        } finally {
          this.loading = false
        }
      },

      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },
      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.buildQuery()
      },

      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.listStatus = data.data.assignOrderStatus.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                  name: item.name,
                  bgColor: item.bgColor,
                  class: item?.class ?? 'text-primary',
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
      search() {
        // if (this.dateRange.endDate) {
        //   this.filters.dateTransactionTo = moment(this.dateRange.endDate).format(
        //     "YYYY/MM/DD"
        //   );
        // } else delete this.filters.dateTransactionTo;
        // if (this.dateRange.startDate) {
        //   this.filters.dateTransactionFrom = moment(
        //     this.dateRange.startDate
        //   ).format("YYYY/MM/DD");
        // } else delete this.filters.dateTransactionFrom;
        // for (const key in this.filters) {
        //   if (this.filters[key] === "0") delete this.filters[key];
        // }
      },
      async submitForm() {
        // this.selectAll = false
        this.pagination.page = 1
        await this.buildQuery()
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.filters.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      async getRegions() {
        try {
          this.loading = true
          const data = await StaffService.getRegions()
          if (data.data.length > 0) {
            this.dataConfigRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          this.loading = false
          console.log(e)
        }
        this.loading = false
      },
      getRole(role) {
        const objRole = this.MaRole.find(s => s.id === role)
        return objRole ? objRole.text : role
      },
      totalAssign(item) {
        return item.successAssignAmount + item.failedAssignAmount
      },
    },
  }
</script>
<style scoped></style>
